import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function imgParallax() {
  gsap.registerPlugin(ScrollTrigger);

  if (document.querySelector('.js-parallax')) {
    gsap.utils.toArray('.js-parallax').forEach((el) => {
      const y = el.getAttribute('data-y') || -100;
      gsap.to(el, {
        y: y,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.5, // スクロールに追従する滑らかさ
          // markers: true // デバッグ用
        },
      });
    });
  }
}
